export const DESKTOP_WIDTH = 1180;
export const DESKTOP_MARGIN = 35;

export const TABLET_WIDTH = 732;
export const TABLET_MARGIN = 15;

export const PHONE_MARGIN = 25;



// WEBPACK FOOTER //
// ./src/components/styles/pageLayout.js